import styled from 'styled-components'

export const Link = styled.a<{ color: string }>`
  color: ${(props) => props.color};
  text-decoration: none;
  font-weight: 600;
`
